/**
 * Anims.
 * 
 */

/**
 * Anims.
 * Reveal animations.
 */

const gsap = require("gsap/dist/gsap").gsap;
const ScrollTrigger = require("gsap/dist/ScrollTrigger").ScrollTrigger;

gsap.registerPlugin(ScrollTrigger);

function initAnims() {

	// ANIM REVEAL ---------------------------------------------------------------

	const revealItems = document.querySelectorAll(".anim-reveal");

	revealItems.forEach((item) => {
		gsap.set(item, { opacity: 0 });

		gsap.to(item, {
			scrollTrigger: {
				trigger: item,
				start: "top bottom",
			},
			autoAlpha: 1,
			duration: 1,
			ease: "power2.inOut",
		});
	});


	// ANIM SLIDE REVEAL CHILDREN ------------------------------------------------

	const slideRevealChildrenItems = document.querySelectorAll(".anim-slide-reveal-children");

	slideRevealChildrenItems.forEach((item) => {
		const children = Array.from(item.children);

		gsap.set(children, { opacity: 0 });

		gsap.fromTo(children, {
			y: 100,
		}, {
			scrollTrigger: {
			trigger: children[0],
			start: "top bottom-=10%",
			},
			y: 0,
			autoAlpha: 1,
			duration: 1.8,
			stagger: .1,
			ease: "power2.out",
		});
	});
}

initAnims();